import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { EnumObject } from '@card-software/library';

@Injectable({
  providedIn: 'root',
})
export class EnumsProxyService {
  private readonly httpClient = inject(HttpClient);
  private baseUrl = `${environment.proxyUrls.financeApi}/api/v1/enums`;

  public getAll(): Observable<EnumObject[]> {
    return this.httpClient.get<EnumObject[]>(`${this.baseUrl}`);
  }
}
